import { useContext } from "react";
import { ServiceContext } from "../_context/service.context.jsx";
export default function useServiceContextHook() {
  const values = useContext(ServiceContext);
  return values;
}